import { info, redDanger, success, warning } from '@/constants/colors';
import { DPIBreakpoints } from '@/constants/dpi';

export const dpiIndicatorColorsBreakpoints: [DPIBreakpoints, string][] = [
  [ DPIBreakpoints.BAD, redDanger ],
  [ DPIBreakpoints.MEDIUM, warning ],
  [ DPIBreakpoints.GOOD, info ],
  [ DPIBreakpoints.EXCELLENT, success ],
];
